import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicLaplacePDE = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SOLVING PDEs USING LAPLACE TRANSFORM"
      videos={[
        "https://www.youtube.com/embed/cL0VOrcse2E?list=PLU6SqdYcYsfIWugLkTq1nMoU3rDDx7xpG"
      ]}
      takeaways={[
        { text: "Practice as many problems as you can" }
      ]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicLaplacePDE;